// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"flip-to-front"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20 4H8V16H20V4Z","fill-rule":"evenodd","stroke-linecap":"square","stroke-width":2,"clip-rule":"evenodd"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M10.5 20H9.5M5.5 20H4V18.5M15.5 20H14.5M4 13.5V14.5M4 8.5V9.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-flip-to-front')
export default class FlipToFrontIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'flip-to-front',
    }
  }
}
